import { Injectable, inject } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, exhaustMap, mergeMap } from 'rxjs/operators';

import { ReportsDashboardTemplatesHttpClient } from './dashboard-templates.http-client';
import { ReportsDashboardTemplatesActions } from './dashboard-templates.store';
import { prefixTemplateLibraryComponentId } from '../helpers/template-library-component-id';
import {
  ReportsLibraryComponentsActions,
  TEMPLATES_LIBRARY_SCOPE,
} from '../library-components/library-components.store';

@Injectable({ providedIn: 'root' })
export class ReportsDashboardTemplatesEffects {
  private readonly actions$ = inject(Actions);
  private readonly http = inject(ReportsDashboardTemplatesHttpClient);

  public fetchCollection$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ReportsDashboardTemplatesActions.fetchCollection),
      exhaustMap(() =>
        this.http.fetchCollection().pipe(
          mergeMap(data => [
            ReportsDashboardTemplatesActions.fetchCollectionSuccess({ payload: { data } }),
            ReportsLibraryComponentsActions.addMany({
              payload: {
                components: data.dashboardTemplates.reduce(
                  (acc, template) => [
                    ...acc,
                    ...template.components.map(component => ({
                      ...component,
                      // Prefix to avoid id collision with regular library components
                      libraryId: prefixTemplateLibraryComponentId(component.libraryId, template.id),
                    })),
                  ],
                  [],
                ),
                scope: TEMPLATES_LIBRARY_SCOPE,
              },
            }),
          ]),
          catchError(error =>
            of(
              ReportsDashboardTemplatesActions.fetchCollectionFailed({
                payload: error,
              }),
            ),
          ),
        ),
      ),
    ),
  );
}
